import React, { useState, useCallback, useEffect } from "react";
import SidePanel from "./slidePanel";
import ClientMenu from "./subMenuList/clientMenu";
import AdminMenu from "./subMenuList/AdminMenu";
import Provider from "./subMenuList/Provider";
import Worker from "./subMenuList/Worker";
import Segment from "../../../../common/element/Segment";
import logoImg from "../../../../assets/icons-svg/sidebar/logomark.svg";
import adminImg from "../../../../assets/icons-svg/sidebar/admin.svg";
import clientImg from "../../../../assets/icons-svg/sidebar/client.svg";
// import contractorImg from "../../../../assets/icons-svg/sidebar/provider.svg";
import workerImg from "../../../../assets/icons-svg/sidebar/worker.svg";
import logoutImg from "../../../../assets/icons-svg/sidebar/logout.svg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LogoutUser from "../../../../common/snippet/logOut";
import { updateRoutefunc } from "../../../../redux/classes/common/updateRoute";
import { useDispatch, useSelector } from "react-redux";

const SidebarNav = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [hovered, setHovered] = useState(false);
  const [toggleState, setToggleState] = useState(false);
  const toggleHover = () => setHovered(!hovered);
  const toggleClick = () => setToggleState(!toggleState);
  const [adminMenu, setAdminMenu] = useState(true);
  const [clientMenu, setClientMenu] = useState(false);
  const [contractorMenu, setContractorMenuMenu] = useState(false);
  const [workerMenu, setworkerMenu] = useState(false);
  const [singleSegmentValue, setSingleSegmentValue] = useState(["Admin"]);
  const { updateRoute } = useSelector((state) => state);
  const Navigate = useNavigate();
  const adminMenuClick = () => {
    Navigate("/admin/dashboard");
    setAdminMenu(true);
    setClientMenu(false);
    setContractorMenuMenu(false);
    setworkerMenu(false);
  };
  const clientMenuClick = () => {
    Navigate("/admin/client/view-all-clients");
    setAdminMenu(false);
    setClientMenu(true);
    setContractorMenuMenu(false);
    setworkerMenu(false);
  };
  const contractorMenuClick = () => {
    Navigate("/admin/provider/view-all-provider");
    setAdminMenu(false);
    setClientMenu(false);
    setContractorMenuMenu(true);
    setworkerMenu(false);
  };
  const workerMenuClick = () => {
    Navigate("/admin/worker/view-all-worker");
    setAdminMenu(false);
    setClientMenu(false);
    setContractorMenuMenu(false);
    setworkerMenu(true);
  };
  const onSingleSelectionSegmentChange = useCallback(
    (val) => {
      setSingleSegmentValue(val);
    },
    [setSingleSegmentValue]
  );
  useEffect(() => {
    if (updateRoute) {
      dispatch(updateRoutefunc(false));
      if (
        location.pathname.split("/")[2] == "users" ||
        location.pathname.split("/")[2] == "dashboard" ||
        location.pathname.split("/")[2] == "invoices"
      ) {
        setSingleSegmentValue(["Admin"]);
        setAdminMenu(true);
        setClientMenu(false);
        setContractorMenuMenu(false);
        setworkerMenu(false);
      } else {
        setSingleSegmentValue([location.pathname.split("/")[2]]);
        if (location.pathname.split("/")[2] == "client") {
          setAdminMenu(false);
          setClientMenu(true);
          setContractorMenuMenu(false);
          setworkerMenu(false);
        } else if (location.pathname.split("/")[2] == "provider") {
          setAdminMenu(false);
          setClientMenu(false);
          setContractorMenuMenu(true);
          setworkerMenu(false);
        } else if (location.pathname.split("/")[2] == "worker") {
          setAdminMenu(false);
          setClientMenu(false);
          setContractorMenuMenu(false);
          setworkerMenu(true);
        } else {
          setAdminMenu(false);
          setClientMenu(false);
          setContractorMenuMenu(true);
          setworkerMenu(false);
        }
      }
    }
  }, [updateRoute, dispatch, location.pathname]);
  useEffect(() => {
    dispatch(updateRoutefunc(true));
  }, []);
  return (
    <div className={`flex side-nav-wrap ${toggleState ? "showPanel" : " "}`}>
      <div className={`flex ${hovered ? "hoveredMenu" : ""}`}>
        <div className="side-nav-content side-nav h-full bg-blue-50 side-nav-expand py-5 border-r border-gray-300">
          <div className="side-nav-header">
            <div className="flex items-center mb-7 pb-0.5 justify-center h-10">
              <img className="logo" src={logoImg} alt="" />
              <button
                onClick={toggleClick}
                className="justify-center items-center header-action-item header-action-item-hoverable w-10 h-10 rounded-full hover:bg-blue-100"
              >
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="m18.5 17.97-5-5 5-5m-7 10-5-5 5-5"
                    stroke="#667085"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div className="menu-list">
            <Segment
              value={singleSegmentValue}
              onChange={(val) => onSingleSelectionSegmentChange(val)}
            >
              <Segment.Item value="Admin">
                {" "}
                <div onClick={adminMenuClick}>
                  {" "}
                  <span className="mb-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M9.5 12L11.5 14L16 9.5M9.7019 20.6009C10.0297 20.5575 10.3607 20.6464 10.6218 20.8475L11.8251 21.7708C12.2228 22.0764 12.7761 22.0764 13.1727 21.7708L14.4215 20.812C14.6548 20.6331 14.9492 20.5542 15.2403 20.5931L16.8024 20.7986C17.299 20.8642 17.7779 20.5875 17.9701 20.1242L18.5712 18.6709C18.6834 18.3987 18.8989 18.1832 19.1711 18.0709L20.6243 17.4699C21.0876 17.2787 21.3643 16.7988 21.2987 16.3021L21.101 14.7966C21.0576 14.4688 21.1465 14.1377 21.3476 13.8766L22.2709 12.6733C22.5764 12.2755 22.5764 11.7222 22.2709 11.3256L21.312 10.0767C21.1332 9.84339 21.0543 9.54896 21.0932 9.25785L21.2987 7.69568C21.3643 7.19902 21.0876 6.72015 20.6243 6.52793L19.1711 5.92684C18.8989 5.81462 18.6834 5.59907 18.5712 5.32685L17.9701 3.87356C17.779 3.41024 17.299 3.13358 16.8024 3.19913L15.2403 3.40468C14.9492 3.44468 14.6548 3.3658 14.4226 3.18802L13.1738 2.22916C12.7761 1.92361 12.2228 1.92361 11.8262 2.22916L10.5774 3.18802C10.3441 3.3658 10.0496 3.44468 9.75856 3.40691L8.19647 3.20136C7.69984 3.1358 7.221 3.41246 7.02879 3.87578L6.42884 5.32907C6.31552 5.60018 6.09998 5.81573 5.82889 5.92906L4.37568 6.52904C3.91238 6.72126 3.63574 7.20013 3.70129 7.69679L3.90683 9.25897C3.9446 9.55007 3.86572 9.84451 3.68796 10.0767L2.72915 11.3256C2.42362 11.7233 2.42362 12.2767 2.72915 12.6733L3.68796 13.9222C3.86683 14.1555 3.94571 14.4499 3.90683 14.741L3.70129 16.3032C3.63574 16.7999 3.91238 17.2787 4.37568 17.471L5.82889 18.0721C6.10109 18.1843 6.31663 18.3998 6.42884 18.672L7.0299 20.1253C7.221 20.5887 7.70096 20.8653 8.19758 20.7998L9.7019 20.6009Z"
                        stroke="#0E4E9A"
                        stroke-width="1.66667"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="text-xs font-semibold">Admin</span>
                </div>
              </Segment.Item>
              <Segment.Item value="client">
                <div onClick={clientMenuClick}>
                  {" "}
                  <span className="mb-1 active">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                    >
                      <path
                        d="M19.318 4.84647L19.318 4.84648C19.7151 4.91279 20.0063 5.2563 20.0063 5.65874V18.6823C20.0063 19.1371 19.6378 19.5058 19.1828 19.5058H13.3945C12.9399 19.5058 12.5711 19.1367 12.5711 18.6823C12.5711 18.2278 12.9399 17.8587 13.3945 17.8587H18.3595L18.3594 6.35648L11.3239 5.18397V18.6823C11.3239 19.1367 10.9552 19.5058 10.5004 19.5058C10.0458 19.5058 9.67711 19.1367 9.67711 18.6823V4.21176C9.67711 3.96961 9.78347 3.73994 9.96818 3.58353C10.1528 3.42699 10.3972 3.3597 10.6357 3.39948C10.6357 3.39948 10.6357 3.39948 10.6357 3.39948L19.318 4.84647Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M12.5716 15.0647C12.5716 14.6098 12.9401 14.2413 13.395 14.2413H16.2891C16.7442 14.2413 17.1127 14.6098 17.1127 15.0647V18.6824C17.1127 19.1373 16.7442 19.5059 16.2891 19.5059H13.395C12.94 19.5059 12.5716 19.1373 12.5716 18.6824V15.0647ZM14.2186 17.8589H15.4657V15.8883H14.2186V17.8589Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M3.88895 15.0647C3.88895 14.6098 4.25758 14.2413 4.71251 14.2413H7.60664C8.06159 14.2413 8.43008 14.6098 8.43008 15.0647V18.6824C8.43008 19.1373 8.06162 19.5059 7.60664 19.5059H4.71251C4.25756 19.5059 3.88895 19.1373 3.88895 18.6824V15.0647ZM5.5361 17.8589H6.78309V15.8883H5.5361V17.8589Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M1.95411 0.505331L1.95421 0.505348L10.6365 1.95258C11.0335 2.01877 11.3246 2.36218 11.3246 2.76485V18.6824C11.3246 19.1372 10.9563 19.5058 10.5012 19.5058H4.71291C4.25828 19.5058 3.88959 19.1367 3.88959 18.6824C3.88959 18.2281 4.25828 17.8589 4.71291 17.8589H9.67783L9.6779 3.46259L2.64234 2.28983V18.6824C2.64234 19.1367 2.27365 19.5059 1.81903 19.5059C1.36429 19.5059 0.995591 19.1367 0.995591 18.6824V1.31762C0.995591 1.07549 1.10216 0.846099 1.28667 0.68964C1.47135 0.532789 1.71573 0.465851 1.95411 0.505331Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M15.4657 11.0854C15.4657 10.8305 15.6725 10.6236 15.9273 10.6236H16.6509C16.9059 10.6236 17.1127 10.8304 17.1127 11.0854V11.809C17.1127 12.0638 16.9059 12.2708 16.6509 12.2708H15.9273C15.6725 12.2708 15.4657 12.0638 15.4657 11.809V11.0854Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M12.5711 11.0854C12.5711 10.8305 12.778 10.6236 13.0329 10.6236H13.7564C14.0113 10.6236 14.2182 10.8304 14.2182 11.0854V11.809C14.2182 12.0638 14.0114 12.2708 13.7564 12.2708H13.0329C12.7779 12.2708 12.5711 12.0638 12.5711 11.809V11.0854Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M12.5711 8.19138C12.5711 7.93656 12.7779 7.72959 13.0329 7.72959H13.7564C14.0114 7.72959 14.2182 7.93654 14.2182 8.19138V8.91494C14.2182 9.16977 14.0114 9.37673 13.7564 9.37673H13.0329C12.778 9.37673 12.5711 9.16978 12.5711 8.91494V8.19138Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M15.4657 8.19138C15.4657 7.93658 15.6724 7.72959 15.9273 7.72959H16.6509C16.9059 7.72959 17.1127 7.93654 17.1127 8.19138V8.91494C17.1127 9.16977 16.9059 9.37673 16.6509 9.37673H15.9273C15.6725 9.37673 15.4657 9.16976 15.4657 8.91494V8.19138Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M6.78306 11.0854C6.78306 10.8305 6.98987 10.6236 7.24485 10.6236H7.96841C8.22328 10.6236 8.43008 10.8305 8.43008 11.0854V11.809C8.43008 12.0638 8.22331 12.2708 7.96841 12.2708H7.24485C6.98986 12.2708 6.78306 12.0638 6.78306 11.809V11.0854Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M3.8884 11.0854C3.8884 10.8305 4.09521 10.6236 4.3502 10.6236H5.07375C5.32858 10.6236 5.53555 10.8304 5.53555 11.0854V11.809C5.53555 12.0638 5.32861 12.2708 5.07375 12.2708H4.3502C4.09521 12.2708 3.8884 12.0638 3.8884 11.809V11.0854Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M3.8884 8.19138C3.8884 7.93656 4.09519 7.72959 4.3502 7.72959H5.07375C5.3286 7.72959 5.53555 7.93652 5.53555 8.19138V8.91494C5.53555 9.16979 5.32861 9.37673 5.07375 9.37673H4.3502C4.09521 9.37673 3.8884 9.16978 3.8884 8.91494V8.19138Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M6.78306 8.19138C6.78306 7.93656 6.98985 7.72959 7.24485 7.72959H7.96841C8.2233 7.72959 8.43008 7.93657 8.43008 8.19138V8.91494C8.43008 9.16974 8.22331 9.37673 7.96841 9.37673H7.24485C6.98986 9.37673 6.78306 9.16978 6.78306 8.91494V8.19138Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M6.78306 5.29734C6.78306 5.04252 6.98985 4.83555 7.24485 4.83555H7.96841C8.2233 4.83555 8.43008 5.04252 8.43008 5.29734V6.0209C8.43008 6.27584 8.22329 6.48269 7.96841 6.48269H7.24485C6.98989 6.48269 6.78306 6.27588 6.78306 6.0209V5.29734Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M3.8884 5.29734C3.8884 5.04252 4.09519 4.83555 4.3502 4.83555H5.07375C5.3286 4.83555 5.53555 5.04248 5.53555 5.29734V6.0209C5.53555 6.27588 5.32859 6.48269 5.07375 6.48269H4.3502C4.09523 6.48269 3.8884 6.27588 3.8884 6.0209V5.29734Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                    </svg>
                  </span>
                  <span className="text-xs font-semibold">Client</span>
                </div>
              </Segment.Item>
              <Segment.Item value="provider">
                <div onClick={contractorMenuClick}>
                  <span className="mb-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M19.6658 20.8745C20.4709 20.8745 21.1214 20.2225 21.1214 19.4191V15.5467C21.1214 14.7434 20.4709 14.0914 19.6658 14.0914H13.8557C13.0506 14.0914 12.4 14.7434 12.4 15.5467V19.4191C12.4 20.2225 13.0506 20.8745 13.8557 20.8745H19.6658ZM19.6658 19.5128H13.8557C13.804 19.5128 13.762 19.4707 13.762 19.4191V15.5467C13.762 15.4951 13.804 15.4531 13.8557 15.4531H19.6658C19.7174 15.4531 19.7594 15.4951 19.7594 15.5467V19.4191C19.7594 19.4707 19.7174 19.5128 19.6658 19.5128Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M19.7593 15.5458C19.7593 16.0251 19.3703 16.4141 18.891 16.4141H14.6303C14.151 16.4141 13.762 16.0251 13.762 15.5458C13.762 15.1699 13.4569 14.8648 13.081 14.8648C12.7051 14.8648 12.4 15.1699 12.4 15.5458C12.4 16.7769 13.3992 17.7761 14.6303 17.7761H18.891C20.1221 17.7761 21.1213 16.7769 21.1213 15.5458C21.1213 15.1699 20.8162 14.8648 20.4403 14.8648C20.0644 14.8648 19.7593 15.1699 19.7593 15.5458Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M18.3105 14.889C18.6312 14.889 18.8915 14.6287 18.8915 14.308V13.5333C18.8915 12.785 18.2857 12.1777 17.5359 12.1777H15.9865C15.2367 12.1777 14.6309 12.785 14.6309 13.5333V14.308C14.6309 14.6287 14.8912 14.889 15.2119 14.889H18.3105ZM17.7295 13.8727H15.7929V13.5333C15.7929 13.4265 15.8796 13.3397 15.9865 13.3397H17.5359C17.6427 13.3397 17.7295 13.4265 17.7295 13.5333V13.8727Z"
                        fill="#0E4E9A"
                        stroke="#0E4E9A"
                        stroke-width="0.2"
                      />
                      <path
                        d="M11.28 14.0664C9.40316 14.098 5.83487 14.7346 4.06036 18.5573C3.84841 19.0142 3.88479 19.737 5.23027 19.776C6.57575 19.815 9.106 19.7923 10.666 19.776"
                        stroke="#0E4E9A"
                        stroke-width="1.95"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <circle
                        cx="12.0698"
                        cy="7.90674"
                        r="3.75986"
                        stroke="#0E4E9A"
                        stroke-width="1.95"
                      />
                    </svg>
                  </span>
                  <span className="text-xs font-semibold">Provider</span>
                </div>
              </Segment.Item>
              <Segment.Item value="worker">
                {" "}
                <div onClick={workerMenuClick}>
                  <span className="mb-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M17.8092 21.4389H7.1907C6.05217 21.4389 5.12598 20.5128 5.12598 19.3742V4.62625C5.12598 3.48772 6.05212 2.56152 7.1907 2.56152H17.8094C18.9479 2.56152 19.8741 3.48773 19.8741 4.62625V19.3742C19.8741 20.5127 18.9478 21.4389 17.8092 21.4389ZM18.1041 4.62592C18.1041 4.46308 17.9714 4.33094 17.8092 4.33094H7.1907C7.02846 4.33094 6.89573 4.46309 6.89573 4.62592C6.89573 20.0499 6.73113 19.6689 7.19065 19.6689C18.1284 19.6689 18.1041 19.8564 18.1041 19.3739L18.1041 4.62592Z"
                        fill="#0E4E9A"
                      />
                      <path
                        d="M13.9745 6.98594H11.0249C10.5364 6.98594 10.14 6.59008 10.14 6.10106C10.14 5.61203 10.5365 5.21619 11.0249 5.21619H13.9745C14.4629 5.21619 14.8594 5.61205 14.8594 6.10106C14.8594 6.59009 14.4629 6.98594 13.9745 6.98594Z"
                        fill="#0E4E9A"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.4997 9.56846C11.6437 9.56846 10.9497 10.2624 10.9497 11.1185C10.9497 11.9745 11.6437 12.6685 12.4997 12.6685C13.3558 12.6685 14.0498 11.9745 14.0498 11.1185C14.0498 10.2624 13.3558 9.56846 12.4997 9.56846ZM9.54974 11.1185C9.54974 9.48922 10.8705 8.16846 12.4997 8.16846C14.129 8.16846 15.4498 9.48922 15.4498 11.1185C15.4498 12.7477 14.129 14.0685 12.4997 14.0685C10.8705 14.0685 9.54974 12.7477 9.54974 11.1185ZM9.22418 17.1685H15.7753C15.0009 16.189 13.8197 15.5685 12.4997 15.5685C11.1798 15.5685 9.99857 16.189 9.22418 17.1685ZM8.04923 16.3994C9.07135 15.0467 10.683 14.1685 12.4997 14.1685C14.3165 14.1685 15.9281 15.0467 16.9503 16.3994C16.9554 16.4063 16.9607 16.4133 16.966 16.4203C17.0485 16.5293 17.1474 16.66 17.2194 16.7885C17.3103 16.9509 17.3826 17.1483 17.3782 17.3904C17.3746 17.5861 17.3159 17.764 17.2478 17.9008C17.1798 18.0375 17.0732 18.1917 16.9192 18.3125C16.7131 18.4743 16.4915 18.5284 16.3103 18.5501C16.1565 18.5686 15.9776 18.5685 15.8137 18.5685C15.8045 18.5685 15.7953 18.5685 15.7861 18.5685H9.21335C9.20421 18.5685 9.19501 18.5685 9.18577 18.5685C9.02186 18.5685 8.84302 18.5686 8.68924 18.5501C8.50803 18.5284 8.28642 18.4743 8.08028 18.3125C7.92631 18.1917 7.81973 18.0375 7.75167 17.9008C7.68361 17.764 7.62487 17.5861 7.62129 17.3904C7.61686 17.1483 7.68914 16.9509 7.78012 16.7885C7.85212 16.66 7.95099 16.5293 8.03344 16.4203C8.03877 16.4133 8.04405 16.4063 8.04923 16.3994Z"
                        fill="#0E4E9A"
                      />
                      <path
                        d="M15.7753 17.1685V17.2685C15.8136 17.2685 15.8486 17.2465 15.8653 17.212C15.882 17.1775 15.8775 17.1365 15.8538 17.1064L15.7753 17.1685ZM9.22418 17.1685L9.14574 17.1064C9.12196 17.1365 9.11747 17.1775 9.13418 17.212C9.15088 17.2465 9.18585 17.2685 9.22418 17.2685V17.1685ZM8.04923 16.3994L7.96945 16.3392H7.96945L8.04923 16.3994ZM16.9503 16.3994L16.8705 16.4597L16.8705 16.4597L16.9503 16.3994ZM16.966 16.4203L16.8863 16.4807L16.8863 16.4807L16.966 16.4203ZM17.2194 16.7885L17.3066 16.7396L17.2194 16.7885ZM17.3782 17.3904L17.2782 17.3886V17.3886L17.3782 17.3904ZM16.9192 18.3125L16.981 18.3912L16.9192 18.3125ZM16.3103 18.5501L16.2983 18.4509L16.3103 18.5501ZM15.8137 18.5685L15.8137 18.6685H15.8137L15.8137 18.5685ZM9.18577 18.5685L9.18581 18.6685H9.18581L9.18577 18.5685ZM8.68924 18.5501L8.70115 18.4509H8.70115L8.68924 18.5501ZM8.08028 18.3125L8.14201 18.2338H8.14201L8.08028 18.3125ZM7.62129 17.3904L7.72127 17.3886L7.62129 17.3904ZM7.78012 16.7885L7.86737 16.8374H7.86737L7.78012 16.7885ZM8.03344 16.4203L7.95369 16.36L7.95369 16.36L8.03344 16.4203ZM11.0497 11.1185C11.0497 10.3176 11.6989 9.66846 12.4997 9.66846V9.46846C11.5885 9.46846 10.8497 10.2072 10.8497 11.1185H11.0497ZM12.4997 12.5685C11.6989 12.5685 11.0497 11.9193 11.0497 11.1185H10.8497C10.8497 12.0297 11.5885 12.7685 12.4997 12.7685V12.5685ZM13.9498 11.1185C13.9498 11.9193 13.3006 12.5685 12.4997 12.5685V12.7685C13.411 12.7685 14.1498 12.0297 14.1498 11.1185H13.9498ZM12.4997 9.66846C13.3006 9.66846 13.9498 10.3176 13.9498 11.1185H14.1498C14.1498 10.2072 13.411 9.46846 12.4997 9.46846V9.66846ZM12.4997 8.06846C10.8153 8.06846 9.44974 9.43399 9.44974 11.1185H9.64974C9.64974 9.54444 10.9257 8.26846 12.4997 8.26846V8.06846ZM15.5498 11.1185C15.5498 9.43399 14.1842 8.06846 12.4997 8.06846V8.26846C14.0738 8.26846 15.3498 9.54444 15.3498 11.1185H15.5498ZM12.4997 14.1685C14.1842 14.1685 15.5498 12.8029 15.5498 11.1185H15.3498C15.3498 12.6925 14.0738 13.9685 12.4997 13.9685V14.1685ZM9.44974 11.1185C9.44974 12.8029 10.8153 14.1685 12.4997 14.1685V13.9685C10.9257 13.9685 9.64974 12.6925 9.64974 11.1185H9.44974ZM15.7753 17.0685H9.22418V17.2685H15.7753V17.0685ZM12.4997 15.6685C13.7874 15.6685 14.9404 16.2737 15.6969 17.2305L15.8538 17.1064C15.0615 16.1044 13.8519 15.4685 12.4997 15.4685V15.6685ZM9.30263 17.2305C10.0591 16.2737 11.2121 15.6685 12.4997 15.6685V15.4685C11.1476 15.4685 9.93803 16.1044 9.14574 17.1064L9.30263 17.2305ZM12.4997 14.0685C10.6498 14.0685 9.00937 14.9629 7.96945 16.3392L8.12902 16.4597C9.13333 15.1306 10.7161 14.2685 12.4997 14.2685V14.0685ZM17.03 16.3392C15.9901 14.9629 14.3496 14.0685 12.4997 14.0685V14.2685C14.2834 14.2685 15.8662 15.1306 16.8705 16.4597L17.03 16.3392ZM17.0458 16.36C17.0405 16.3529 17.0352 16.346 17.03 16.3392L16.8705 16.4597C16.8757 16.4666 16.881 16.4736 16.8863 16.4807L17.0458 16.36ZM17.3066 16.7396C17.2307 16.604 17.1274 16.4678 17.0458 16.36L16.8863 16.4807C16.9696 16.5908 17.0641 16.7159 17.1321 16.8374L17.3066 16.7396ZM17.4782 17.3922C17.483 17.1279 17.4037 16.913 17.3066 16.7396L17.1321 16.8374C17.217 16.9889 17.2822 17.1688 17.2782 17.3886L17.4782 17.3922ZM17.3373 17.9453C17.4102 17.799 17.4743 17.6063 17.4782 17.3922L17.2782 17.3886C17.275 17.5658 17.2216 17.7291 17.1583 17.8562L17.3373 17.9453ZM16.981 18.3912C17.1494 18.259 17.2645 18.0917 17.3373 17.9453L17.1583 17.8562C17.095 17.9833 16.9969 18.1244 16.8575 18.2338L16.981 18.3912ZM16.3222 18.6494C16.5133 18.6265 16.755 18.5684 16.981 18.3912L16.8575 18.2338C16.6711 18.3801 16.4696 18.4303 16.2983 18.4509L16.3222 18.6494ZM15.8137 18.6685C15.9761 18.6685 16.1613 18.6687 16.3222 18.6494L16.2983 18.4509C16.1517 18.4684 15.9792 18.4685 15.8138 18.4685L15.8137 18.6685ZM15.7861 18.6685C15.7953 18.6685 15.8044 18.6685 15.8137 18.6685L15.8138 18.4685C15.8045 18.4685 15.7953 18.4685 15.7861 18.4685V18.6685ZM9.21335 18.6685H15.7861V18.4685H9.21335V18.6685ZM9.18581 18.6685C9.19506 18.6685 9.20423 18.6685 9.21335 18.6685V18.4685C9.20419 18.4685 9.19497 18.4685 9.18573 18.4685L9.18581 18.6685ZM8.67733 18.6494C8.83821 18.6687 9.02342 18.6685 9.18581 18.6685L9.18573 18.4685C9.02031 18.4685 8.84782 18.4684 8.70115 18.4509L8.67733 18.6494ZM8.01854 18.3912C8.24445 18.5684 8.48616 18.6265 8.67733 18.6494L8.70115 18.4509C8.5299 18.4303 8.32839 18.3801 8.14201 18.2338L8.01854 18.3912ZM7.66215 17.9453C7.73501 18.0917 7.85007 18.259 8.01854 18.3912L8.14201 18.2338C8.00256 18.1244 7.90446 17.9833 7.8412 17.8562L7.66215 17.9453ZM7.5213 17.3922C7.52522 17.6063 7.58929 17.799 7.66215 17.9453L7.8412 17.8562C7.77794 17.7291 7.72451 17.5658 7.72127 17.3886L7.5213 17.3922ZM7.69288 16.7396C7.59577 16.913 7.51647 17.1279 7.5213 17.3922L7.72127 17.3886C7.71725 17.1688 7.78252 16.9889 7.86737 16.8374L7.69288 16.7396ZM7.95369 16.36C7.8721 16.4678 7.76883 16.604 7.69288 16.7396L7.86737 16.8374C7.93541 16.7159 8.02989 16.5908 8.11318 16.4807L7.95369 16.36ZM7.96945 16.3392C7.96428 16.346 7.95904 16.3529 7.95369 16.36L8.11318 16.4807C8.11851 16.4736 8.12381 16.4666 8.12902 16.4597L7.96945 16.3392Z"
                        fill="#0E4E9A"
                      />
                    </svg>
                  </span>
                  <span className="text-xs  font-semibold">Worker</span>
                </div>
              </Segment.Item>
            </Segment>
            <LogoutUser logOut="admin" />
            {/* <button className="logout flex flex-col items-center">
              <img src={logoutImg} alt="" />
            </button> */}
          </div>
        </div>

        <SidePanel>
          {adminMenu && <AdminMenu />}
          {clientMenu && <ClientMenu />}
          {contractorMenu && <Provider />}
          {workerMenu && <Worker />}
        </SidePanel>
      </div>
    </div>
  );
};
export default SidebarNav;
